import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Person } from "../../../utils/backend-types";
import type { Doc } from "../../DeliveryOverview/DeliveryOverview.types";

function getSuppliedColumn(persons: Array<Person>): MRT_ColumnDef<Doc> {
  return {
    header: "Belieferter",
    accessorKey: "supplied",
    accessorFn: (row) =>
      persons.find((person) => person.id === row.supplied)?.name || "",
    filterVariant: "multi-select"
  };
}

export { getSuppliedColumn };
